import DashboardLayout from "../../components/DashboardLayout";
import SalaryTable from "../../components/SalaryTable";

const SuperadminDashboard = () => {
  return (
    <DashboardLayout role="superadmin">
      {/* <h2>Superadmin Dashboard</h2> */}
      <SalaryTable />
    </DashboardLayout>
  );
};

export default SuperadminDashboard;
